import React, { useEffect, useState, useRef } from "react";
import {
  getStoreTransactions,
  putOrder,
  getAppStoreItems,
  getOrders,
  getStripeExpressDashboardLink,
} from "apis";
import { DatePicker } from "components";
import { FlexColumn, FlexRow, H1, Button } from "appStyles";
import ReactToPrint from "react-to-print";
import OrderCard from "./OrderCard";
import ItemsTable from "./ItemsTable";
import ItemChipsContainer from "./ItemChipsContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MaterialTabSelector } from "components";
import { css } from "react-emotion";
import Modal from "@material-ui/core/Modal";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import TuneIcon from "@material-ui/icons/Tune";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#F17F7F",
    },
    secondary: {
      main: "#88d1d4",
    },
  },
  overrides: {
    // Style sheet name ⚛️
    MuiTablePagination: {
      // Name of the rule
      actions: {
        // Some CSS
        marginLeft: "0px",
      },
    },
    MuiTableContainer: {
      root: {
        flex: 1,
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        width: "100%",
      },
    },
    MuiTableSortLabel: {
      root: {
        color: "#89D2D3 !important",
      },
    },
  },
});

const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;
const boldButton = css`
  display: inline-block;
  width: auto;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: rgba(120, 120, 120, 0.5);
`;

const headerText = css`
  text-align: center;
  font-size: 1.2em;
  margin: 0px;
  @media only screen and (min-width: 768px) {
    text-align: center;
    font-size: 1.5em;
    margin: 0px;
  }
`;

const headerContainer = css`
  height: 25px;
  align-items: center;
  margin: 10px 0px;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    height: 25px;
    align-items: center;
    margin: 20px 0px;
    justify-content: center;
  }
`;

const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  color: rgb(95, 99, 104);
  @media only screen and (min-width: 768px) {
    font-size: 1.75em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

var days = 7; // Days you want to subtract
var date = new Date();
var sevenDaysAgo = new Date(date.getTime() - days * 24 * 60 * 60 * 1000);

function Store(props) {
  const id = props.location.state.appId;
  const adminUserId = props.location.state.userId;
  const shippoToken = props.location.state.shippoToken;
  // console.log(shippoToken);

  const stripeExpressDetailsSubmitted =
    props.location.state.stripeExpressDetailsSubmitted;
  const stripeExpressRequiresMoreInfo =
    props.location.state.stripeExpressRequiresMoreInfo;

  if (!id) props.history.push("/lobby");
  // console.dir(props);
  const [transactions, setTransactions] = useState([]);
  const [storeItems, setStoreItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState(
    JSON.parse(sessionStorage.getItem("selectedItems")) || []
  );
  const [showItemsModal, setShowItemsModal] = useState(false);

  const [dateSince, setDateSince] = useState(
    parseInt(sessionStorage.getItem("dateSince")) || sevenDaysAgo
  );

  // console.log("Got transactions!");
  // console.log(transactions);

  const getSelectedItems = (selected) => {
    setSelectedItems(selected);
    sessionStorage.setItem("selectedItems", JSON.stringify(selected));
    toggleShowItemsModal();
  };
  const deleteSelectedItems = (selected) => {
    setSelectedItems(selected);
    sessionStorage.setItem("selectedItems", JSON.stringify(selected));
  };

  const [hideTabs, setHideTabs] = useState(false);
  const componentRef = useRef();

  const checkOrderStatus = (transaction, status) => {
    return transaction.orderStatus === status;
  };

  const toggleTabs = () => {
    // console.log("toggling tabs");
    setHideTabs(!hideTabs);
  };

  const toggleShowItemsModal = () => {
    setShowItemsModal(!showItemsModal);
  };

  const renderFilterByItemsModal = () => {
    if (!showItemsModal) return null;
    return (
      <Modal
        open={showItemsModal}
        disableAutoFocus={true}
        onClose={toggleShowItemsModal}
        style={{
          top: "25%",
          width: window.innerWidth > parseInt("768px") ? "375px" : "375px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div>
          <ItemsTable
            rows={storeItems}
            setSelectedItems={getSelectedItems}
            selectedItems={selectedItems}
          ></ItemsTable>
        </div>
      </Modal>
    );
  };

  const cancelOrder = async (orderId, orderToUpdate) => {
    orderToUpdate["orderStatus"] = "CANCELLED";
    try {
      const result = await putOrder(orderId, orderToUpdate);
      loadOrders();
    } catch (e) {
      console.error(e);
    }
  };

  const requestUpdateOrder = async (
    orderStatus,
    orderToUpdate,
    orderId,
    paidNotes
  ) => {
    if (orderStatus === "PLACED") {
      orderToUpdate["orderStatus"] = "READY";
    }
    if (orderStatus === "CARD_REJECTED") {
      orderToUpdate["orderStatus"] = "READY";
    }
    if (orderStatus === "PAID" && !paidNotes) {
      orderToUpdate["orderStatus"] = "FULFILLED";
    }

    try {
      const result = await putOrder(orderId, orderToUpdate);
      loadOrders();
    } catch (e) {
      console.error(e);
    }
  };

  const convertDate = (d) => {
    if (d === null) return;
    d = new Date(d.getTime() - 3000000);
    var date_format_str =
      d.getFullYear().toString() +
      "-" +
      ((d.getMonth() + 1).toString().length == 2
        ? (d.getMonth() + 1).toString()
        : "0" + (d.getMonth() + 1).toString()) +
      "-" +
      (d.getDate().toString().length == 2
        ? d.getDate().toString()
        : "0" + d.getDate().toString()) +
      " " +
      (d.getHours().toString().length == 2
        ? d.getHours().toString()
        : "0" + d.getHours().toString()) +
      ":" +
      ((parseInt(d.getMinutes() / 5) * 5).toString().length == 2
        ? (parseInt(d.getMinutes() / 5) * 5).toString()
        : "0" + (parseInt(d.getMinutes() / 5) * 5).toString()) +
      ":00";
    return date_format_str;
  };

  function getFormattedDate(date) {
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return month + "/" + day + "/" + year;
  }

  const renderItems = (status) => {
    let componentToReturn = null;
    if (transactions && !status) {
      componentToReturn = (
        <div>
          {transactions.map((transaction) => {
            return (
              <OrderCard
                key={transaction.orderId}
                requestUpdateOrder={requestUpdateOrder}
                cancelOrder={cancelOrder}
                transaction={transaction}
                appId={id}
                adminUserId={adminUserId}
                {...props}
              />
            );
          })}
        </div>
      );
    } else if (transactions && status) {
      componentToReturn = (
        <div>
          {transactions
            .filter((transaction) => checkOrderStatus(transaction, status))
            .map((filteredTransaction) => {
              return (
                <OrderCard
                  key={filteredTransaction.orderId}
                  requestUpdateOrder={requestUpdateOrder}
                  cancelOrder={cancelOrder}
                  transaction={filteredTransaction}
                  appId={id}
                  {...props}
                />
              );
            })}
        </div>
      );
    }
    if (!componentToReturn.props.children.length && status) {
      if (status === "PLACED") {
        status = "RECEIVED";
      }
      componentToReturn = (
        <div>
          <p
            style={{
              fontStyle: "italic",
              fontWeight: "normal",
              fontSize: "15px",
              color: "black",
            }}
          >
            You have no{" "}
            <span style={{ textDecoration: "underline" }}>
              {status.toString().toLowerCase()}
            </span>{" "}
            orders as of {getFormattedDate(new Date(dateSince))}!
          </p>
        </div>
      );
    }
    return componentToReturn;
  };
  const tabs = [
    {
      text: "All",
      value: "all",
      tabComponent: renderItems(),
    },
    {
      text: "Recieved",
      value: "placed",
      tabComponent: renderItems("PLACED"),
    },
    {
      text: "Ready",
      value: "ready",
      tabComponent: renderItems("READY"),
    },
    {
      text: "Paid",
      value: "paid",
      tabComponent: renderItems("PAID"),
    },
    {
      text: "Fulfilled",
      value: "fulfilled",
      tabComponent: renderItems("FULFILLED"),
    },
    {
      text: "Cancelled",
      value: "cancelled",
      tabComponent: renderItems("CANCELLED"),
    },
  ];

  const loadTransactions = async () => {
    if (dateSince) {
      try {
        const parsedDate = convertDate(new Date(dateSince));
        const result = await getStoreTransactions(
          id,
          parsedDate,
          selectedItems
        );
        // console.log(result);
        if (Array.isArray(result)) {
          setTransactions(result);
        }
      } catch (e) {
        setTransactions([]);
        console.error(e);
      }
    }
  };

  const loadOrders = async () => {
    if (dateSince) {
      try {
        const parsedDate = convertDate(new Date(dateSince));
        const result = await getOrders(id, parsedDate, selectedItems);
        // console.log(result);
        if (Array.isArray(result)) {
          setTransactions(result);
        }
      } catch (e) {
        setTransactions([]);
        console.error(e);
      }
    }
  };

  const loadAppStoreItems = async () => {
    try {
      const result = await getAppStoreItems(id);
      // console.log("***** GOT APP STORE ITEMS ******");
      // console.log(result);
      if (Array.isArray(result)) {
        setStoreItems(result);
      }
    } catch (e) {
      setStoreItems([]);
      console.error(e);
    }
  };

  useEffect(() => {
    loadOrders();
  }, [dateSince, selectedItems]);

  useEffect(() => {
    loadAppStoreItems();
  }, [selectedItems]);

  const handleDateChange = (date) => {
    sessionStorage.setItem("dateSince", date);
    setDateSince(date);
  };

  const goBack = () => {
    props.history.push("/application");
  };

  // console.log("Got All store items");
  // console.log(storeItems);

  const getStripeUrl = async (id) => {
    try {
      const result = await getStripeExpressDashboardLink(id);
      return result.text();
    } catch (e) {
      console.error(e);
      alert("Error: Failed to retrieve stripe url");
    }
  };

  const renderShippoPrompt = () => {
    if (shippoToken === null) {
      return null;
    }
    if (shippoToken) {
      return (
        <div
          style={{
            cursor: "pointer",
            fontSize: "15px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Button
            style={{
              display: "inline-flex",
              alignItems: "center",
              margin: "0px",
              textAlign: "center",
              marginLeft: "20px",
              height: "42px",
              boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
            }}
            onClick={
              () =>
                // getStripeUrl(id).then((url) => {
                Object.assign(document.createElement("a"), {
                  target: "_blank",
                  href: "https://goshippo.com/",
                }).click()
              // })
            }
          >
            {/* <FontAwesomeIcon icon="truck" /> */}
            <a
              style={{
                fontWeight: "bold",
                color: "white",
                textDecoration: "none",
                marginLeft: "5px",
              }}
            >
              Go to Shippo
            </a>
          </Button>
        </div>
      );
    }
  };

  const renderStripePrompt = () => {
    if (
      stripeExpressRequiresMoreInfo === null &&
      stripeExpressRequiresMoreInfo === null
    ) {
      return null;
    }

    if (stripeExpressDetailsSubmitted && !stripeExpressRequiresMoreInfo) {
      return (
        <div
          style={{
            cursor: "pointer",
            fontSize: "15px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            style={{
              display: "inline-flex",
              alignItems: "center",
              margin: "0px",
              textAlign: "center",
              marginLeft: "20px",
              height: "42px",
              boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
            }}
            onClick={() =>
              getStripeUrl(id).then((url) => {
                Object.assign(document.createElement("a"), {
                  target: "_blank",
                  href: url,
                }).click();
              })
            }
          >
            <FontAwesomeIcon icon="dollar-sign" />
            <a
              style={{
                fontWeight: "bold",
                color: "white",
                textDecoration: "none",
                marginLeft: "5px",
              }}
            >
              View Payouts
            </a>
          </Button>
        </div>
      );
    }

    return (
      <div
        style={{
          padding: "10px 20px",
          border: "1px solid rgb(137, 210, 211)",
          borderRadius: "5px",
          margin: "10px 20px",
          background: "#e6f3f3",
        }}
      >
        <p style={{ color: "black", fontWeight: "bold" }}>
          {stripeExpressDetailsSubmitted &&
            stripeExpressRequiresMoreInfo &&
            "Stripe Needs to Verify More Information"}
          {!stripeExpressDetailsSubmitted &&
            stripeExpressRequiresMoreInfo &&
            "Setup Payout Information"}
        </p>

        {stripeExpressDetailsSubmitted && stripeExpressRequiresMoreInfo ? (
          <p
            style={{
              fontSize: "12px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            Your app won’t be able to process payments and you won’t receive
            payouts until this is complete. Sometimes Stripe requires extra
            verification to finalize your account. Usually they will require 2-3
            additional steps so bear with us. After completing the required
            steps, please return to Mobile360 and refresh the screen to see if
            more steps are required.
          </p>
        ) : (
          <p
            style={{
              fontSize: "12px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            Mobile360 has integrated with Stripe for secure credit card
            processing. Just like all credit card processors, Stripe charges a
            standard credit card processing fee which can be found
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/pricing"}
            >
              here
            </a>
            . To accept payments via credit card and to receive daily payouts to
            your bank account or debit card, you must complete your Stripe
            setup. The first payout takes 7 - 14 days after your first purchase
            as specified{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/docs/payouts"}
            >
              here
            </a>
            . By doing so, you agree to their fees,{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/legal"}
            >
              Services Agreement
            </a>{" "}
            and{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/connect-account/legal"}
            >
              Stripe Connected Account Agreement
            </a>
            . Please remember, Mobile360 simply serves as the intermediary
            between you and your customers, but you are responsible for all
            transactions that flow through your app, including refunds and
            refutations.
          </p>
        )}

        <Button
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: "5px 0px 10px 0px",
            textAlign: "center",
            height: "30px",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
          onClick={() =>
            getStripeUrl(id).then((url) => {
              Object.assign(document.createElement("a"), {
                target: "_blank",
                href: url,
              }).click();
            })
          }
        >
          {" "}
          <a
            style={{
              fontSize: "12px",
              color: "white",
              fontWeight: "bold",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            {stripeExpressDetailsSubmitted &&
              stripeExpressRequiresMoreInfo &&
              "Continue to Stripe"}
            {!stripeExpressDetailsSubmitted &&
              stripeExpressRequiresMoreInfo &&
              "Setup Payout Information Now"}
          </a>
        </Button>
      </div>
    );
  };

  const deleteSelectedItem = (id) => {
    const items = selectedItems.filter((item) => item !== id);

    setSelectedItems(items);
    sessionStorage.setItem("selectedItems", JSON.stringify(items));
  };
  const renderSelectedItemChips = () => {
    if (selectedItems.length === 0 || storeItems.length === 0) {
      return null;
    }
    return (
      <ItemChipsContainer
        selectedItems={selectedItems}
        storeItems={storeItems}
        deleteSelectedItem={deleteSelectedItem}
        deleteAll={deleteSelectedItems}
      ></ItemChipsContainer>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={storeContainer}>
        <FontAwesomeIcon
          className={arrowStyle}
          icon="arrow-left"
          onClick={goBack}
        />
      </div>
      <div>
        <div ref={componentRef} className={storeContainer}>
          <FlexRow className={headerContainer}>
            <H1 className={headerText}>Order History</H1>
          </FlexRow>
          {renderShippoPrompt()}
          {renderStripePrompt()}

          <FlexRow style={{ height: "50px", marginBottom: "10px" }}>
            <FlexRow style={{ justifyContent: "flex-start" }}>
              <DatePicker
                datePickerProps={{
                  dateFormat: "MM/dd/yyyy",
                  style: {
                    marginLeft: "0px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    innerWidth: "200px",
                    innerBackgroundPosition: "175px center",
                    width: "auto",
                  },
                }}
                minDateFalse={true}
                maxDate={Date.now()}
                isDateChecker={true}
                title="As of:"
                selected={dateSince}
                onChange={handleDateChange}
              />
              <Button
                className={boldButton}
                background="#89D2D3"
                onClick={toggleShowItemsModal}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  margin: "10px 20px",
                  textAlign: "center",
                  marginLeft: "20px",
                  height: "42px",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                }}
              >
                <TuneIcon
                  fontSize={"small"}
                  style={{ marginRight: "5px" }}
                ></TuneIcon>
                Add Filters
              </Button>
            </FlexRow>{" "}
            <FlexColumn style={{ alignItems: "flex-end" }}>
              <ReactToPrint
                onBeforeGetContent={toggleTabs}
                onAfterPrint={toggleTabs}
                pageStyle="
              @media print {
                html, body, div {
                  height: initial !important;
                  overflow: initial !important;
                  -webkit-print-color-adjust: exact;
                  page-break-inside: avoid; }}
              @page { size: auto; margin: 10mm;}
            "
                trigger={() => (
                  <div
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                    }}
                  >
                    <FontAwesomeIcon icon="print" />{" "}
                    <a
                      style={{
                        fontWeight: "normal",
                        color: "black",
                        textDecoration: "none",
                      }}
                    >
                      Print All
                    </a>
                  </div>
                )}
                content={() => componentRef.current}
              />
            </FlexColumn>
          </FlexRow>

          {renderSelectedItemChips()}
          <MaterialTabSelector tabs={tabs} hideTabs={hideTabs} isStore={true} />
          {renderFilterByItemsModal()}
        </div>
      </div>
    </ThemeProvider>
  );
}

export default Store;
